import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(auth)/signup/SignupClient.jsx");
